module.exports = __webpack_public_path__ + "static/media/11.3b9c4ddb.jpg";